import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Upload, Image, Button, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const EditModal = ({
  isModalVisible,
  handleOk,
  handleCancel,
  loading,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        name: initialValues.name,
        description: initialValues.description,
      });
      //   form.setFieldsValue({ image: fileList.length > 0 ? fileList[0] : null });

      if (initialValues.full_image_url) {
        // Ensure you're using the correct image key
        const fileData = {
          uid: "-1",
          name: "image",
          status: "done",
          url: initialValues.full_image_url,
        };
        setFileList([fileData]);
        form.setFieldsValue({ image: fileData });
      } else {
        setFileList([]);
      }
    }
  }, [initialValues, form, isModalVisible]);

  const handleChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
    form.setFieldsValue({ image: fileList.length > 0 ? fileList[0] : null });
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Select</div>
    </div>
  );

  //   const onFinish = (values) => {
  //     handleOk({ ...values, image: fileList[0]?.originFileObj || initialValues.image || null });
  //     form.resetFields();
  //     setFileList([]);
  //     setPreviewImage("");
  //   };

  const onFinish = async (values) => {
    const updatedValues = {};

    // Check for changed fields
    Object.keys(values).forEach((key) => {
      if (values[key] !== initialValues[key]  && key !== "image") {
        updatedValues[key] = values[key];
      }
    });

    // Handle image separately
    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      updatedValues.image = fileList[0].originFileObj;
    }

    // Only proceed if there's something to update
    if (Object.keys(updatedValues).length > 0) {
      await handleOk(initialValues?.id, updatedValues);
    } else {
      notification.error({
        message: "No changes detected",
        duration: 2,
      });
    }
  };

  return (
    <Modal
      title="Edit Preference Master"
      open={isModalVisible}
      footer={null}
      onCancel={() => {
        handleCancel();
        form.resetFields();
        setFileList([]);
        setPreviewImage("");
      }}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input placeholder="Enter Preference name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input.TextArea rows={3} placeholder="Enter description" />
        </Form.Item>
        <Form.Item
          name="image"
          label="Select Image"
          rules={[{ required: true, message: "Please upload an image" }]}
        >
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            beforeUpload={() => false}
            maxCount={1}
            accept=".jpg,.jpeg,.png,.svg"
            onRemove={async (file) => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "Are you sure you want to delete this image?",
                  okText: "Yes",
                  cancelText: "No",
                  onOk: () => {
                    resolve(true); // allow deletion
                  },
                  onCancel: () => {
                      resolve(false) // cancel deletion
                  },
                });
              });
            }}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
                toolbarRender: () => null,
              }}
              src={previewImage}
            />
          )}
        </Form.Item>
        <Form.Item>
          <div className="flex items-center justify-end gap-4">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Changes
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
